module.exports = __webpack_public_path__ + "cd083e9003324d7b0fb767a634a2eba1.svg";